import { Component } from '@angular/core';

@Component({
    selector: 'bb-amount-page-ui',
    templateUrl: './bb-amount-page-ui.component.html',
    standalone: false,
})
export class AmountPageComponent {}
